import { render, staticRenderFns } from "./BankSlipPayment.vue?vue&type=template&id=290192cf&scoped=true"
import script from "./BankSlipPayment.vue?vue&type=script&lang=js"
export * from "./BankSlipPayment.vue?vue&type=script&lang=js"
import style0 from "./BankSlipPayment.scss?vue&type=style&index=0&id=290192cf&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290192cf",
  null
  
)

export default component.exports